"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackNoResultPage = void 0;
const enums_1 = require("../enums");
const trackGA4EventWithCleanUp_1 = require("./trackGA4EventWithCleanUp");
function trackNoResultPage(click_element, click_text, click_url) {
    const eventData = {
        eventName: enums_1.GA4EventName.ClickTextLink,
        feature_category: enums_1.GA4FeatureCategory.Search,
        click_element,
        click_text,
        click_url,
    };
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventCategory: enums_1.EventCategory.NoResultsPage,
        eventAction: enums_1.ClickEventType.TEXT_CLICK,
        eventLabel: enums_1.GA4EventLabel.Support,
        eventValue: undefined,
        nonInteraction: false,
        eventData,
    });
}
exports.trackNoResultPage = trackNoResultPage;
//# sourceMappingURL=trackNoResultPage.js.map